<template>
  <main id="week-list" class="tab-view-container padding-y">
    <div v-if="!list.length">无</div>
    <div v-else>
      <div v-for="(item, key) in list" :key="key">
        <h2 v-if="key > 0 && item.start.isBefore(list[key - 1].start, 'year')">
          {{ item.start.format("YYYY") }}
        </h2>
        <Item :start="item.start" :end="item.end" :list="item.items" />
      </div>
    </div>
  </main>
</template>

<script>
import moment from "moment"
import Item from "./Item"

export default {
  props: ["homework", "schedule", "teacher"],
  components: {
    Item,
  },
  data() {
    return {
      list: []
    }
  },
  watch: {
    homework: {
      immediate: true,
      handler: function () {
        this.sortList()
      }
    }
  },
  methods: {
    sortList() {
      this.list = []
      this.homework.forEach(item => {
        const date = moment(item.schedule_time.start_time)
        const node = this.list.find(i => date.isBetween(i.start, i.end))
        if (node) {
          node.items.push(item)
        } else {
          this.list.push({
            start: moment(date).isoWeekday(1).hour(0).minute(0).second(0),
            end: moment(date).isoWeekday(7).hour(23).minute(59).second(59),
            items: [item]
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#week-list {
  h2 {
    margin: 15px 0 10px 0;
    font-size: 1.2rem;
  }
}
</style>